module.exports = __webpack_public_path__ + "img/Modou1.efaa3e1e.png";